import React, { PropsWithChildren } from "react";

import Icon from "../../icon";

import { StyledAlert } from "./styles";

const Alert = ({ children }: PropsWithChildren<{}>) => (
    <StyledAlert>
        <Icon i="alert" /> {children}
    </StyledAlert>
);

export default Alert;
